<template>
    <div>
        <breadcrumb :routerList="[{to:'/yuce/wxhuizong',title:'外销列表'},{title:'外销列表(详情)'}]"/>
        <div class="h-content">
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="proCode"
                                :show-overflow-tooltip="true"
                                label="产品编号">
                        </el-table-column>
                        <el-table-column
                                prop="useNum"
                                :show-overflow-tooltip="true"
                                label="使用数量">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.useNum}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="useTime"
                                :show-overflow-tooltip="true"
                                label="使用时间">
                        </el-table-column>
                        <el-table-column
                                v-if="showT"
                                :show-overflow-tooltip="true"
                                prop="approvalOpinion"
                                label="审核意见">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="h-tableB h-mrt30">
                    <div class="h-pagination2 h-pageCenter">
                        <pagination :page="q" @query="query"/>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30    bbbb">
                <div class="h-pieceTitle2 hang">
                    <h1 class="h1">审批意见</h1>
                    <el-form :model="formLabelAlign" label-position="right" :inline="true"
                             class="demo-ruleForm h-formbLine inputO">
                        <el-form-item label="审批意见" class="h-elformWrap-2 " :required="true"
                                      style="margin:30px 0 20px 29px">
                            <el-input v-if="showText1" v-model="shenhetext" placeholder="请输入"
                                      class="zidaoO"></el-input>
                            <el-input v-if="showText2" v-model="shenhetext" class="zidaoO" disabled></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="apprButton">
                <el-row>
                    <el-button class="h-btn h-bBtn h-bgwhite" @click="returnTable">返回</el-button>
                    <el-button v-if="showrefuse" class="h-btn h-bBtn h-bgred" @click="auditFail">驳回</el-button>
                    <el-button v-if="showpass" class="h-btn h-bBtn h-bggreen" @click="auditPass">通过</el-button>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>

    import ss from '../../../api/SystemService';

    export default {
        data() {
            return {
                tableData: {},
                formLabelAlign:{},
                shenhetext:'',
                showrefuse: false,
                showpass: false,
                showText1: false,
                showText2: true,
                showT: false,
                id: '',
            }
        },
        mounted() {

        },
        created() {
            this.query();
        },
        methods: {
            query() {
                this.id = this.$route.query.id;
                ss.jiediao.showData(this.id).then(rd => {
                    this.tableData = rd;
                    this.shenhetext = rd.approvalOpinion;
                })
                if (this.tableData.agree == 0) {
                    this.showrefuse = true;
                    this.showpass = true;
                    this.showText1 = true;
                    this.showText2 = false;
                }
            },
            auditPass() {
                ss.waixiao.shTG(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
                this.returnTable();
            },
            auditFail() {
                var reg = /^\s$/;
                if (reg.test(this.shenhetext)) {
                    this.$msg.msge("审核意见不能为空!");
                    return;
                }
                if (this.shenhetext == "") {
                    this.$msg.msge("审核意见不能为空!");
                    return;
                }
                ss.waixiao.shBTG(this.tableData).then(rd => {
                    this.$msg.msgs(rd.msg);
                })
                this.returnTable();
            },
            returnTable() {
                // this.$router.go(-1);
                this.$router.push({path: '/personal/dealCenter'})
            }
        }
    }
</script>
<style scoped>
    /*--------------- 审批样式 ----------------*/
    .inputO{
        margin-top: 19px;
    }
    .h1{
        margin: 20px 0 0 31px;
    }
    .bbbb{
        background-color: white;
        padding-bottom: 30px;
    }
    .apprButton {
        margin-left: 6rem;
        margin-top: 30px;
        padding-bottom: 20px;
    }
    .cancel {
        width: 18%;
    }
    .pass {
        background-color: #006aca;
        color: white;
        width: 18%;
    }
    .refuse {
        background-color: #24b5b8;
        color: white;
        width: 18%;
    }

    /*--------------- 审批样式 ------------------*/
</style>